import {
  FETCH_KITCHEN_DISHES,
  FETCH_KITCHEN_DISHES_SUCCESS,
  FETCH_KITCHEN_DISHES_FAILURE,
  SAVE_KITCHEN_DISH,
  DELETE_KITCHEN_DISH,
  FETCH_KITCHEN_MENUS,
  FETCH_KITCHEN_MENUS_SUCCESS,
  FETCH_KITCHEN_MENUS_FAILURE,
  SAVE_KITCHEN_MENU,
  PUBLISH_KITCHEN_MENU,
  UNPUBLISH_KITCHEN_MENU,
  FETCH_MEAL_SITTINGS,
  FETCH_MEAL_SITTINGS_SUCCESS,
  FETCH_MEAL_SITTINGS_FAILURE,
} from "./constants";

const initialState = {
  isFetchingDishes: false,
  isFetchingMenus: false,
  isSaving: false,
  dishes: [],
  menus: [],
  from: null,
  to: null,
  error: null,
  // { [locationId]: { status, sittings, isDefault, canEdit, loading } }
  // status: loading | ready | missing (404) | needs_update (503) | forbidden | error
  mealSittings: {},
};

const withSittings = (state, locationId, patch) => {
  if (!locationId) return state;
  const all = state.mealSittings || {};
  return {
    ...state,
    mealSittings: {
      ...all,
      [locationId]: { ...(all[locationId] || {}), ...patch },
    },
  };
};

const KitchenMenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KITCHEN_DISHES:
      return { ...state, isFetchingDishes: true, error: null };
    case FETCH_KITCHEN_DISHES_SUCCESS:
      return {
        ...state,
        isFetchingDishes: false,
        isSaving: false,
        dishes: action.payload?.dishes ?? [],
      };
    case FETCH_KITCHEN_DISHES_FAILURE:
      return {
        ...state,
        isFetchingDishes: false,
        isSaving: false,
        error: true,
      };
    case FETCH_KITCHEN_MENUS:
      return { ...state, isFetchingMenus: true, error: null };
    case FETCH_KITCHEN_MENUS_SUCCESS:
      return {
        ...state,
        isFetchingMenus: false,
        isSaving: false,
        menus: action.payload?.menus ?? [],
        from: action.payload?.from ?? state.from,
        to: action.payload?.to ?? state.to,
      };
    case FETCH_KITCHEN_MENUS_FAILURE:
      return { ...state, isFetchingMenus: false, isSaving: false, error: true };
    case SAVE_KITCHEN_DISH:
    case DELETE_KITCHEN_DISH:
    case SAVE_KITCHEN_MENU:
    case PUBLISH_KITCHEN_MENU:
    case UNPUBLISH_KITCHEN_MENU:
      return { ...state, isSaving: true };
    case FETCH_MEAL_SITTINGS: {
      const id = action.payload?.locationId;
      const prev = (state.mealSittings || {})[id];
      return withSittings(state, id, {
        status: prev?.status || "loading",
        loading: true,
      });
    }
    case FETCH_MEAL_SITTINGS_SUCCESS:
      return withSittings(state, action.payload?.locationId, {
        status: "ready",
        loading: false,
        sittings: action.payload?.sittings ?? null,
        isDefault: !!action.payload?.isDefault,
        canEdit: action.payload?.canEdit ?? null,
      });
    case FETCH_MEAL_SITTINGS_FAILURE:
      return withSittings(state, action.payload?.locationId, {
        status: action.payload?.status || "error",
        loading: false,
      });
    default:
      return state;
  }
};

export default KitchenMenuReducer;
